export default {
  packages: { loading: false, data: [], error: '' },
};
